const AllProjects = [
  {
    id: '096',
    name: 'CHAYA',
    category: 'full-stack',
    tier: 'core',
    photo:
      'https://i.ibb.co/rwcCwTc/screencapture-bookchaya-2022-04-09-22-14-37-min-1-1-1.png',
    description:
      "Bangladesh's first space-sharing marketplace, connecting space owners with people looking to book a space for short-term stays or events like parties.",
    technologies: [
      { name: 'React' },
      { name: 'Context API' },
      { name: 'Tailwind' },
      { name: 'Firebase' },
      { name: 'NodeJS' },
      { name: 'SSLCOMMERZ' },
    ],
    github: 'https://github.com/PriontoAbdullah',
    website: 'https://www.bookchaya.com/',
    status: 'featured',
  },

  {
    id: '097',
    name: 'CHAYA Rooms',
    category: 'full-stack',
    tier: 'core',
    photo:
      'https://i.ibb.co/QXwnYLS/screencapture-chayarooms-2023-09-01-16-53-02-1-1.png',
    description:
      'A community-driven housing platform for landlords and tenants, connecting verified tenants to a network of ready-to-move-in homes in safe communities.',
    technologies: [
      { name: 'Next.js' },
      { name: 'React' },
      { name: 'Redux' },
      { name: 'Tailwind' },
      { name: 'NodeJS' },
      { name: 'SSLCOMMERZ' },
    ],
    github: 'https://github.com/PriontoAbdullah',
    website: 'https://www.chayarooms.com/',
    status: 'featured',
  },

  {
    id: '098',
    name: 'Anushilon - Virtual Science Lab',
    category: 'full-stack',
    tier: 'core',
    photo: 'https://i.ibb.co/rc8wNNF/Oze0RSF.png',
    description:
      'A virtual science lab built on the idea that lab experiments can be taught more efficiently online, useful anywhere physical lab equipment is scarce.',
    technologies: [
      { name: 'React' },
      { name: 'Redux' },
      { name: 'Tailwind' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'oAuth2' },
    ],
    github: 'https://github.com/PriontoAbdullah/Anushilon-Virtual-Science-Lab',
    website: 'https://anushilon-bd.web.app/',
    status: 'featured',
  },

  {
    id: '301',
    name: 'CampusVerse DIU',
    category: 'full-stack',
    tier: 'core',
    photo:
      'https://i.ibb.co.com/nN6m3tDt/campusverse-connect-diu-web-app-1-1.png',
    description:
      'An all-in-one campus platform for DIU students, combining a marketplace, food ordering, ride sharing, study groups, and clubs into one unified app with student auth.',
    technologies: [
      { name: 'Vite' },
      { name: 'TypeScript' },
      { name: 'React' },
      { name: 'shadcn/ui' },
      { name: 'Tailwind CSS' },
      { name: 'Firebase' },
    ],
    github: 'https://github.com/PriontoAbdullah/campusverse-connect-diu',
    website: 'https://campusverse-connect-diu.web.app/',
    status: 'featured',
  },

  {
    id: '302',
    name: 'EdFellow Connect Hub',
    category: 'full-stack',
    tier: 'core',
    photo: 'https://i.ibb.co.com/NBCr3kv/edfellow-connect-hub-1-1.png',
    description:
      'A collaborative platform connecting students, mentors, and educators for knowledge sharing, mentorship, and community-driven learning experiences.',
    technologies: [
      { name: 'Next.js' },
      { name: 'TypeScript' },
      { name: 'React' },
      { name: 'Tailwind CSS' },
      { name: 'Node.js' },
      { name: 'MongoDB' },
    ],
    github: 'https://github.com/PriontoAbdullah/edfellow-connect-hub',
    website: 'https://edfellow-connect-hub.vercel.app/',
    status: 'featured',
  },

  {
    id: '203',
    name: 'Food Club',
    category: 'full-stack',
    tier: 'core',
    photo:
      'https://i.ibb.co/vmZJDqf/screencapture-foodclubuk-2023-09-02-00-35-01-1-1.png',
    description:
      'A membership-based platform where members unlock guaranteed discounts from partner restaurants, helping them save money on food across the city.',
    technologies: [
      { name: 'Next.js' },
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Stripe' },
    ],
    github: 'https://github.com/PriontoAbdullah/',
    website: 'https://www.foodclubuk.com/',
    status: 'featured',
  },

  {
    id: '099',
    name: 'Smart Dhopa',
    category: 'full-stack',
    tier: 'core',
    photo: 'https://i.ibb.co/mFgL7Sz/HuD93ZT.png',
    description:
      'An online laundry marketplace where users can browse and book laundry services with a full shopping-cart flow, order tracking, and Firebase auth.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Material UI' },
    ],
    github: 'https://github.com/PriontoAbdullah/Smart-Dhopa-React-App',
    website: 'https://smart-dhopa-online-laundry-app.web.app/',
    status: 'featured',
  },

  {
    id: '100',
    name: "Doctor's Portal",
    category: 'full-stack',
    tier: 'core',
    photo: 'https://i.ibb.co/RcwXfTm/kecWOs1.png',
    description:
      'A single-page appointment booking app where patients pick a date and time with a doctor, who manages appointments and prescribes medicine from a dashboard.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Stripe' },
    ],
    github: 'https://github.com/PriontoAbdullah/Online-Doctors-Portal',
    website: 'https://online-doctors-portal.web.app/',
    status: 'featured',
  },

  {
    id: '104',
    name: 'E-Pharmacy',
    category: 'full-stack',
    tier: 'core',
    photo:
      'https://i.ibb.co/yXKpycc/screencapture-e-pharmacy-bd-web-app-2022-04-09-22-18-05-1-1-1.png',
    description:
      'An online pharmacy platform for browsing and ordering prescription and non-prescription medicine, with orders processed and delivered to your address.',
    technologies: [
      { name: 'React' },
      { name: 'Redux' },
      { name: 'NodeJS' },
      { name: 'ExpressJS' },
      { name: 'MongoDB' },
      { name: 'Tailwind' },
    ],
    github: 'https://github.com/PriontoAbdullah/E-Pharmacy',
    website: 'https://e-pharmacy-bd.web.app/',
    status: 'featured',
  },

  {
    id: '112',
    name: 'Real Homes',
    category: 'full-stack',
    tier: 'extra',
    photo: 'https://i.ibb.co/x6xpdkH/real-homes.png',
    description:
      'A real estate finder web app for browsing and filtering buy/sell property listings, built with Next.js, NestJS, and a third-party real estate API.',
    technologies: [
      { name: 'NestJS' },
      { name: 'ReactJS' },
      { name: 'Rapid API' },
      { name: 'Chackra UI' },
      { name: 'Axios' },
      { name: 'Framer Motion' },
    ],
    github: 'https://github.com/PriontoAbdullah/Real-Homes-Next.js',
    website: 'https://real-homes.vercel.app/',
    status: 'common',
  },

  {
    id: '111',
    name: 'Payra Chat App',
    category: 'full-stack',
    tier: 'extra',
    photo: 'https://i.ibb.co/ZhWVTGQ/Mu7dTir.png',
    description:
      'A real-time chat application with JWT authentication, where admins manage users and people can search by email or phone to start a conversation.',
    technologies: [
      { name: 'Socket.io' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Mongoose' },
      { name: 'Node' },
      { name: 'JWT' },
    ],
    github: 'https://github.com/PriontoAbdullah/Payra-Chat-App',
    website: 'https://payra-chat-app.herokuapp.com/',
    status: 'common',
  },

  {
    id: '204',
    name: 'Dev Archive Diu',
    category: 'full-stack',
    tier: 'extra',
    photo:
      'https://i.ibb.co/2qPB4pK/screencapture-dev-archive-diu-vercel-app-2023-09-02-00-49-24-1.png',
    description:
      'A developer community platform for DIU students to showcase projects, bid on freelance work, ask questions, and get discovered by recruiters online.',
    technologies: [
      { name: 'React' },
      { name: 'Redux' },
      { name: 'NodeJS' },
      { name: 'ExpressJS' },
      { name: 'MongoDB' },
      { name: 'Soket.io' },
    ],
    github: 'https://github.com/PriontoAbdullah/',
    website: 'https://dev-archive-diu.vercel.app/',
    status: 'common',
  },

  {
    id: '201',
    name: 'DIU Book Shop',
    category: 'full-stack',
    tier: 'extra',
    photo:
      'https://i.ibb.co/Y8HyVv0/screencapture-diu-book-buy-sell-web-app-2023-09-02-00-07-37-1-1.png',
    description:
      'A marketplace for the DIU community to buy and sell used books, offering a convenient alternative to physical bookstores while reducing book waste.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Tailwind CSS' },
      { name: 'Node.js' },
      { name: 'Express.js' },
      { name: 'SSLCOMMERZ' },
    ],
    github: 'https://github.com/PriontoAbdullah/',
    website: 'https://diu-book-buy-sell.web.app/',
    status: 'common',
  },

  {
    id: '101',
    name: 'Red Onion',
    category: 'front-end',
    tier: 'extra',
    photo: 'https://i.ibb.co/3k1Kr5c/O4UbAvb.png',
    description:
      'A food delivery web app with a full shopping-cart flow, where users create an account with email to browse restaurants and place their orders.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'React-Hooks-Form' },
      { name: 'JavaScript' },
    ],
    github:
      'https://github.com/PriontoAbdullah/Red-Onion-Online-Food-Delivery-App',
    website: 'https://red-onion-online-food-946d6.web.app/',
    status: 'common',
  },

  {
    id: '303',
    name: 'Pasha Group',
    category: 'full-stack',
    tier: 'extra',
    photo: 'https://i.ibb.co.com/jvHHkq5Z/pasha-group-1-1.png',
    description:
      'A modern corporate website for Pasha Group paired with an admin dashboard for monitoring business operations, built with responsive design and analytics.',
    technologies: [
      { name: 'React' },
      { name: 'Next.js' },
      { name: 'Tailwind CSS' },
      { name: 'JavaScript' },
      { name: 'Framer Motion' },
      { name: 'Chart.js' },
    ],
    github: 'https://github.com/PriontoAbdullah/pasha-group',
    website: 'https://pasha-group.vercel.app/',
    status: 'common',
  },

  {
    id: '105',
    name: 'Creative Agency',
    category: 'full-stack',
    tier: 'extra',
    photo: 'https://i.ibb.co/9WNjD0V/HMitcZC.png',
    description:
      'A software services marketplace with separate client and admin dashboards, where clients browse, purchase, and review services with role-based access.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'ReactBootstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/creative-agency',
    website: 'https://creative-agency-71.web.app/',
    status: 'common',
  },

  {
    id: '210',
    name: 'Bebsha Lagbe',
    category: 'full-stack',
    tier: 'extra',
    photo:
      'https://i.ibb.co/XLQHfym/screencapture-stunning-narwhal-336632-netlify-app-2023-09-02-00-11-43-min-1-1.png',
    description:
      'A business services marketplace where users browse listings, contact providers, and send inquiries, with an admin dashboard for managing services.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Tailwind' },
      { name: 'Node' },
      { name: 'Express' },
      { name: 'MongoDB' },
    ],
    github: 'https://github.com/',
    website: 'https://stunning-narwhal-336632.netlify.app/',
    status: 'common',
  },

  {
    id: '108',
    name: 'AKK Systems',
    category: 'front-end',
    tier: 'extra',
    photo:
      'https://i.ibb.co/cDRkswH/screencapture-akk-systems-web-app-2022-04-09-22-58-35-min-1.png',
    description:
      'A company website for an ERP solutions provider serving the RMG (garments and accessories) sector, showcasing their products and services online.',
    technologies: [
      { name: 'React' },
      { name: 'Bootstrap' },
      { name: 'Scss' },
      { name: 'Firebase' },
      { name: 'Javascript' },
      { name: 'React-Router' },
    ],
    github: 'https://github.com/PriontoAbdullah',
    website: 'https://akk-systems.web.app/',
    status: 'common',
  },

  {
    id: '103',
    name: 'Weeding Photography',
    category: 'front-end',
    tier: 'extra',
    photo: 'https://i.ibb.co/9sf0vk7/hvm0PdQ.jpg',
    description:
      'A wedding photography service platform where clients browse packages, book sessions, and track bookings, with a dashboard for managing messages.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Tailwind' },
      { name: 'Javascript' },
      { name: 'React-Router' },
      { name: 'Context API' },
    ],
    github: 'https://github.com/PriontoAbdullah/Wedding-Photography-Service',
    website: 'https://wedding-photography-bd.web.app/',
    status: 'common',
  },

  {
    id: '102',
    name: 'Resume Builder',
    category: 'front-end',
    tier: 'extra',
    photo: 'https://i.ibb.co.com/Pq66bGQ/resume-builder.png',
    description:
      'A resume builder where users can create, edit, and export a polished, print-ready resume, with sign-in supported through Google or email.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Context-api' },
      { name: 'Bootstrap' },
      { name: 'Scss' },
      { name: 'React-Router' },
    ],
    github: 'https://github.com/PriontoAbdullah/Resume-Builder-Web-App',
    website: 'https://resume-builder-bd.web.app/',
    status: 'common',
  },

  {
    id: '114',
    name: 'E-Learning',
    category: 'front-end',
    tier: 'extra',
    photo: 'https://i.ibb.co/KXKFCbv/dgfdgsd566.png',
    description:
      'A course marketplace front-end where users browse courses, add them to a cart, and check out, built with an emphasis on interactive, engaging UI.',
    technologies: [
      { name: 'React' },
      { name: 'Javascript' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'HTML5' },
      { name: 'CSS3' },
    ],
    github: 'https://github.com/PriontoAbdullah/e-learning-online-courses',
    website: 'https://e-learning-online-courses.netlify.app/',
    status: 'common',
  },
];
export default AllProjects;
